
import { NgModule, ModuleWithProviders } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { HttpClientModule } from '@angular/common/http';
import { UiProvider } from '../providers/ui/ui';
import { ApiProvider } from '../providers/api/api';
import { Device } from '@ionic-native/device'
import { ApiLoginProvider } from './api-login/api-login';
import { UiPhotoLibraryProvider } from './ui-photo-library/ui-photo-library';
import { Camera } from '@ionic-native/camera';
import { DatabaseProvider } from './database/database';
import { ConfigDataProvider } from './config-data/config-data';
import { ApiGetProvider } from './api-get/api-get';
import { TranslateProvider } from './translate/translate';
import { MessagesStoreProvider } from './messages-store/messages-store';
import { AttachmentsStoreProvider } from './attachments-store/attachments-store';
import { TasksStoreProvider } from './tasks-store/tasks-store';
import { AdvalvasItemStoreProvider } from './advalvas-item-store/advalvas-item-store';
import { UsersStoreProvider } from './users-store/users-store';
import { CategoriesStoreProvider } from './categories-store/categories-store';
import { RoomsStoreProvider } from './rooms-store/rooms-store';
import { LocationStoreProvider } from './location-store/location-store';
import { MessageInfoStoreProvider } from './message-info-store/message-info-store';
import { SyncProvider } from './sync/sync';
import { ConnectionProvider } from './connection/connection';
import { File } from '@ionic-native/file';
import { FileTransfer } from '@ionic-native/file-transfer';
import { ApiPostProvider } from './api-post/api-post';
import { CalendarItemsStoreProvider } from './calendar-items-store/calendar-items-store';
import { PermissionsProvider } from './permissions/permissions';
import { CustomDateFormatterProvider } from './custom-date-formatter/custom-date-formatter';


@NgModule({
	providers: [
		Device,
		Camera,
		File,
		FileTransfer
	],
	imports: [
		IonicModule,
		HttpClientModule,
		// HttpModule
	]
})
export class ServiceModule {

	static forRoot(): ModuleWithProviders {

		return {
			ngModule: ServiceModule,
			providers: [
				ApiProvider,
				ApiLoginProvider,
				ApiGetProvider,
				ApiPostProvider,

				AttachmentsStoreProvider,
				MessagesStoreProvider,
				TasksStoreProvider,
				AdvalvasItemStoreProvider,
				UsersStoreProvider,
				LocationStoreProvider,
				CategoriesStoreProvider,
				RoomsStoreProvider,
				MessageInfoStoreProvider,
				CalendarItemsStoreProvider,

				DatabaseProvider,
				ConfigDataProvider,
				TranslateProvider,
				SyncProvider,
				ConnectionProvider,

				UiProvider,
				UiPhotoLibraryProvider,

				PermissionsProvider,
				CustomDateFormatterProvider
			],

		} as ModuleWithProviders;
	}


}


// WEBPACK FOOTER //
// ./src/providers/service.module.ts